import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import colors from "../../constants/colors";
import { MOBILE } from "../../constants/breakpoints";

//Assets
import logo_color from "./../../assets/logo_color.svg";
import link_small from "../../assets/icons/link_small.svg";
import footer_line from "../../assets/footer_line.svg";
import { ReactComponent as Twitter } from '../../assets/icons/socials/Twitter.svg'
import { ReactComponent as Youtube } from '../../assets/icons/socials/Youtube.svg'
import { ReactComponent as Discord } from '../../assets/icons/socials/Discord.svg'
import { ReactComponent as Mail } from '../../assets/icons/socials/Mail.svg'
import footer_bg from "../../assets/footer_bg.svg";
import mobileFooterBg from "./mobileFooterBg";
import footer_blob_mobile from "../../assets/footer_blob_mobile.svg";
import { useNavigate } from "react-router-dom";
import { privacyPath, termsPath } from "../../module/routes/path";

function Footer() {
  return (
    <>
      <MobileFooter />
      <DesktopFooter />
    </>
  );
}

const DesktopFooter = () => {
  const navigate = useNavigate();

  return (
    <section
      css={css`
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 497px;
        background: url(${footer_bg});
        background-repeat: no-repeat;
        background-size: cover;

        @media (max-width: ${MOBILE}px) {
          display: none;
        }
        .linkText:hover{
          cursor: pointer;
          transform: scale(1.1);
          transition: transform 200ms linear;
        }
        .linkImage:hover{
          transform: scale(1.1) rotate(5deg);
          transition: transform 200ms linear;
          cursor: pointer;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          width: 1140px;
          margin: 0 auto;
          flex-direction: column;
          margin-top: 160px;
        `}
      >
        <span
          css={css`
            display: flex;
            width: 100%;
            margin: 0 auto;
            align-items: center;
          `}
        >
          <img
            css={css`
              width: 189.29px;
              height: 26.79px;
            `}
            src={logo_color}
            alt=""
          />
          <span
            css={css`
              display: flex;
              align-items: center;
              column-gap: 49.69px;
              margin-left: auto;
            `}
          >
            {["Pass", "Rewards", "About & FAQ"].map((link: string) => {
              return (
                <p
                  key={"ftl" + link}
                  css={css`
                    color: ${colors.INTERFACE_COLORS_LIGHT_GRAY};
                    font-weight: 500;
                    font-size: 16px;
                  `}
                  className="linkText"
                >
                  {link}
                  <img
                    css={css`
                      width: 12.81px;
                      object-fit: contain;
                      filter: invert(0.4);
                      margin-left: 9.5px;
                    `}
                    src={link_small}
                    alt=""
                  />
                </p>
              );
            })}
            <p
              css={css`
                color: ${colors.INTERFACE_COLORS_LIGHT_GRAY};
                font-weight: 500;
                font-size: 16px;
                opacity: 0.3;
              `}
              className="linkText"
            >
              Proxy Token
            </p>
            <p
              css={css`
                color: ${colors.INTERFACE_COLORS_LIGHT_GRAY};
                font-weight: 500;
                font-size: 16px;
                opacity: 0.3;
              `}
              className="linkText"
            >
              Assets
            </p>
          </span>
        </span>
        <img
          css={css`
            width: 1140px;
            margin-bottom: 24px;
            margin-top: 22px;
            object-fit: contain;
          `}
          src={footer_line}
          alt=""
        />
        <div
          css={css`
            display: flex;
            width: 100%;
            align-items: center;
          `}
        >
          <span
            css={css`
              display: flex;
              width: 100%;
              column-gap: 29px;
            `}
          >
            <Twitter className="linkImage" height={43} width={42} />
            <Youtube className="linkImage" height={43} width={42} />
            <Discord className="linkImage" height={43} width={42} />
            <Mail className="linkImage" height={43} width={42} />
          </span>
          <span
            css={css`
              display: flex;
              align-items: center;
              column-gap: 49.69px;
              margin-left: auto;
            `}
          >
            <p
              css={css`
                color: ${colors.INTERFACE_COLORS_LIGHT_GRAY};
                font-weight: 500;
                font-size: 16px;
                opacity: 0.3;
                width: max-content;
              `}
              onClick={() => navigate(privacyPath)}
              className="linkText"
            >
              Privacy Policy
            </p>
            <p
              css={css`
                color: ${colors.INTERFACE_COLORS_LIGHT_GRAY};
                font-weight: 500;
                font-size: 16px;
                opacity: 0.3;
                width: max-content;
              `}
              className="linkText"
              onClick={() => navigate(termsPath)}
            >
              Terms & Agreements
            </p>
          </span>
        </div>
      </div>
      <p
        css={css`
          color: ${colors.INTERFACE_COLORS_STONE};
          margin: 0 auto;
          margin-top: auto;
          margin-bottom: 25px;
          opacity: 0.6;
        `}
      >
        @2022 Lavabee. All rights reserved
      </p>
    </section>
  );
};

const MobileFooter = () => {
  const navigate = useNavigate();

  return (
    <section
      css={css`
        display: flex;
        position: relative;
        flex-direction: column;
        width: 100%;
        height: 497px;
        background: ${mobileFooterBg};
        background-repeat: no-repeat;
        background-size: cover;
        background-position: left;
        align-items: center;
        padding-top: 100px;
        display: none;
        margin-top: 80px;
        @media (max-width: ${MOBILE}px) {
          display: flex;
        }
      `}
    >
      <img
        css={css`
          width: 189.29px;
          height: 26.79px;
        `}
        src={logo_color}
        alt=""
      />
      <img
        css={css`
          width: 90%;
          margin-bottom: 24px;
          margin-top: 22px;
          object-fit: contain;
        `}
        src={footer_line}
        alt=""
      />
      <span
        css={css`
          display: flex;
          column-gap: 24px;
          justify-content: center;
          flex-wrap: wrap;
          padding: 0 10px;
        `}
      >
        <p
          key={"ftl"}
          css={css`
            color: ${colors.INTERFACE_COLORS_LIGHT_GRAY};
            font-weight: 500;
            font-size: 16px;
          `}
        >
          About & FAQ
        </p>
        <p
          css={css`
            color: ${colors.INTERFACE_COLORS_LIGHT_GRAY};
            font-weight: 500;
            font-size: 16px;
            opacity: 0.3;
          `}
        >
          Proxy Token
        </p>
        <p
          css={css`
            color: ${colors.INTERFACE_COLORS_LIGHT_GRAY};
            font-weight: 500;
            font-size: 16px;
            opacity: 0.3;
          `}
        >
          Assets
        </p>
        <p
          key={"ftl" + "pass"}
          css={css`
            color: ${colors.INTERFACE_COLORS_LIGHT_GRAY};
            font-weight: 500;
            font-size: 16px;
          `}
        >
          Pass
          <img
            css={css`
              width: 12.81px;
              object-fit: contain;
              filter: invert(0.4);
              margin-left: 9.5px;
              filter: grayscale(100%) invert(100%);
            `}
            src={link_small}
            alt=""
          />
        </p>
        <p
          key={"ftl" + "pass"}
          css={css`
            color: ${colors.INTERFACE_COLORS_LIGHT_GRAY};
            font-weight: 500;
            font-size: 16px;
          `}
        >
          Pulse
          <img
            css={css`
              width: 12.81px;
              object-fit: contain;
              filter: invert(0.4);
              margin-left: 9.5px;
              filter: grayscale(100%) invert(100%);
            `}
            src={link_small}
            alt=""
          />
        </p>
      </span>
      <span
        css={css`
          display: flex;
          align-items: center;
          column-gap: 49.69px;
          margin: 0 auto;
          margin-top: 10px;
        `}
      >
        <p
          css={css`
            color: ${colors.INTERFACE_COLORS_STONE};
            font-weight: 400;
            font-size: 14px;
            width: max-content;
          `}
          onClick={() => navigate(privacyPath)}
        >
          Privacy Policy
        </p>
        <p
          css={css`
            color: ${colors.INTERFACE_COLORS_STONE};
            font-weight: 400;
            font-size: 14px;
            width: max-content;
          `}
          onClick={() => navigate(termsPath)}
        >
          Terms & Agreements
        </p>
      </span>
      <span
        css={css`
          display: flex;
          width: 100%;
          column-gap: 29px;
          justify-content: center;
          margin-top: 36px;
        `}
      >
        <Twitter className="linkImage" height={43} width={42} />
        <Youtube className="linkImage" height={43} width={42} />
        <Discord className="linkImage" height={43} width={42} />
        <Mail className="linkImage" height={43} width={42} />
      </span>
      <p
        css={css`
          color: ${colors.INTERFACE_COLORS_STONE};
          margin: 0 auto;
          margin-top: auto;
          margin-bottom: 25px;
          opacity: 0.6;
        `}
      >
        @2022 Lavabee. All rights reserved
      </p>
    </section>
  );
};

export default Footer;
